import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ConnMessageService {

  constructor(private _messageService: MessageService) { }

  //-------------------------------------
  //--       GLOBAL MESSAGE-SERVICE MESSAGES
  //-------------------------------------
  private lastNoInternetToastAt = 0;
  private noInternetTimer: any = null;
  readonly noInternetMessage = 'No internet connection. Please check your network and try again.';

  private isBrowserOffline(): boolean {
    return typeof navigator !== 'undefined' && navigator.onLine === false;
  }

  /**
   * Shows the no-internet toast only if the browser is still offline after a short grace period
   * (brief blips / reconnects stay silent), and at most once every 5s so parallel failing
   * requests don't stack it. Pass graceMs = 0 for an immediate alert.
   */
  showNoInternetToast(graceMs: number = 4000) {
    if (this.noInternetTimer || !this.isBrowserOffline()) return;
    const show = () => {
      this.noInternetTimer = null;
      if (!this.isBrowserOffline()) return;
      const now = Date.now();
      if (now - this.lastNoInternetToastAt < 5000) return;
      this.lastNoInternetToastAt = now;
      this.showToastMessage(this.noInternetMessage);
    };
    if (graceMs <= 0) { show(); return; }
    this.noInternetTimer = setTimeout(show, graceMs);
  }

  showToastMessage(msg: any, type: string="error") {
  if(!msg.publicKey || !msg.sessionId){
    this._messageService.add({ severity: type, summary: 'Message', detail: msg })
  }
  }
}
